module.exports = __webpack_public_path__ + "img/home 1.32a89bda.png";